'use strict';

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

function animateText(h1Element, newText) {
  if (!window.gsap) {
    h1Element.textContent = newText;
    return;
  }
  const isMobile = window.matchMedia('(hover: none)').matches;
  const duration = isMobile ? 0.4 : 0.635;
  window.gsap.killTweensOf(h1Element);
  window.gsap.to(h1Element, {
    opacity: 0,
    y: '2%',
    duration: duration,
    ease: 'power2.out',
    onComplete: () => {
      h1Element.textContent = newText;
      window.gsap.to(h1Element, {
        opacity: 1,
        y: '0%',
        duration: duration,
        ease: 'power2.in',
      });
    },
  });
}

function initializeTextSwitcher(container) {
  const h1 = container.querySelector('#dynamic-text');
  const buttons = Array.from(container.querySelectorAll('text-switcher'));
  if (!h1 || buttons.length === 0) {
    console.warn('Text switcher elements not found. Ensure #dynamic-text and text-switcher elements exist.');
    return;
  }
  let currentActiveButton = null;
  function setActiveButton(activeBtn) {
    buttons.forEach((btn) => btn.classList.remove('active'));
    if (activeBtn) {
      activeBtn.classList.add('active');
      currentActiveButton = activeBtn;
    }
  }
  setActiveButton(buttons[0]);
  h1.textContent = buttons[0]?.getAttribute('data-text') || h1.textContent || '';
  const debouncedAnimateText = debounce(animateText, 100);
  function handleEvent(event) {
    const isTouch = window.matchMedia('(hover: none)').matches;
    const targetButton = event.target.closest('text-switcher');
    if (!targetButton || targetButton === currentActiveButton) {
      return;
    }
    const shouldSwitchText = (isTouch && event.type === 'click') || (!isTouch && event.type === 'mouseenter');
    if (shouldSwitchText) {
      const newText = targetButton.getAttribute('data-text');
      if (newText && h1.textContent !== newText) {
        debouncedAnimateText(h1, newText);
        setActiveButton(targetButton);
      }
    }
  }
  container.addEventListener('click', handleEvent);
  container.addEventListener('mouseenter', handleEvent, true);
}

document.addEventListener('DOMContentLoaded', function () {
  const aboutSectionContainer = document.querySelector('[data-about-text-switcher]');
  if (aboutSectionContainer) {
    initializeTextSwitcher(aboutSectionContainer);
  }
});
